import React, { useState } from "react";
import { Box } from "@mui/material";
import DynamicForm from "../forms/DynamicForm";
import useFetchFormData from "@/hooks/forms/useFetchFormData";
import { FORM_NAMES } from "@/api/services/dynamicForm/formName";
import WithLoadingError from "@/hoc/forms/WithLoadingError";

function MyComponent() {
  const { formData, setFormData, errorMessage, isLoading, hasError } =
    useFetchFormData(FORM_NAMES.EMPLOYEE_LIST.ADD_EMPLOYEE);

  const handleFieldChange = (event, fieldId) => {
    // console.log("Field Changed:", fieldId, "Value:", event);
  };

  const handleButtonClick = (fieldId, btnAction, event) => {
    console.log(`Button Clicked: ${fieldId}, Action: ${btnAction}`, event);
  };

  const handleSubmit = (values) => {
    console.log("Form Submitted:", values);
  };

  return (
    <Box>
      {/* Pass errorMessage to DataWrapper */}
      <WithLoadingError
        isLoading={isLoading}
        error={errorMessage || null}
        data={formData}
        useSkeleton={true}
      >
        <DynamicForm
          formData={formData}
          setFormData={setFormData}
          handleSubmit={handleSubmit}
          handleFieldChange={handleFieldChange}
          handleButtonclick={handleButtonClick}
        />
      </WithLoadingError>
    </Box>
  );
}

export default MyComponent;
